import React, {createRef} from "react"
import {findDOMNode} from "react-dom"

import QuickSearch from "../../model/quick-search"
import QuickSearch_StartScreen from "../start-screen"
import VScroll from "../../../../../core/gd-components/scrolling/custom-v-scroll/v-scroll"
import {QuickSearchResult} from "../../model/search-results"
import ErrorBoundary from "../../../../../core/error-boundary"

type Props = {
    className?          : string
    containerClass?     : string

    quickSearch         : QuickSearch
    skipAutoRegister    : boolean       // used in top panel quick search
}


// const debug = "QuickSearch_SearchResults"
const debug = false

export default class QuickSearch_SearchResults extends React.Component<Props> {

    private refMain: any = createRef()

    constructor(props: Props) {
        super(props)

        if (!this.props.skipAutoRegister) {
            props.quickSearch.componentResults = this
        }
    }

    componentDidUpdate() {
        const mainNode: any = findDOMNode(this.refMain.current)
        const node = mainNode?.getElementsByClassName("item-{0}".f(this.props.quickSearch.keyboardIterator.currentIndex))[0] // find node to scroll to

        debug && console.log(debug, "componentDidUpdate", mainNode, node?.offsetTop, node)

        if (node) {
            this.refMain.current.setScrollTop(node.offsetTop, true, 0)
        }
    }

    public reRender = () => {
        this.forceUpdate()
    }

    render() {
        debug && console.log(debug, "render()")

        const quickSearch = this.props.quickSearch
        const noMatches = quickSearch.results.noResults && !quickSearch.isSearching


        if (!quickSearch.searchEnabled) {
            return <QuickSearch_StartScreen />
        }

        const classes = Classes("main", this.props.className)

        return (
            <VScroll ref={this.refMain} className={classes} containerClass={this.props.containerClass}>
                <div className="ui5-list h-40">
                    <ErrorBoundary>
                        {quickSearch.results.items.map((searchResult : QuickSearchResult, key )=> {
                            const classes = Classes("item-{0}".f(key))
                            return <searchResult.component key          = {key}
                                                           className    = {classes}
                                                           quickSearch  = {quickSearch}
                                                           searchResult = {searchResult} />
                        })}
                    </ErrorBoundary>
                </div>

                {noMatches && (
                    <div className="flex-row-center-center w-100-percent ui5-txt-no-accent-default m-b-40">
                        No results found. Try using different keywords or reviewing your search settings.
                    </div>
                )}

                {quickSearch.isSearching && (
                    <div className="flex-row-center-center w-100-percent ui5-txt-no-accent-default m-b-40">
                        Searching...
                    </div>
                )}
            </VScroll>
        )
    }
}
